module.exports = __webpack_public_path__ + "static/img/Planificaciones_1_banner planif@4x.c329ca7f.png";